/*!
 *
 * components.js
 *
 */

'use strict';

require('jquery');
require('jquery.easing');
require('jquery.transit');
require('jquery.mousewheel');
require('jquery-mobile-events');
require('origin');
require('slick-carousel');
require('isotope.pkgd');
require('underscore');
require('fancybox')($);

var linker = require('linker');
var slideScroll = require('slide-scroll');
require('menu');
require('fade-contents');
require('fit-image');
var localmenu = require('localmenu');
var sort = require('sort');
var page2top = require('page2top');
require('tab');
require('lightbox');
var topJob = require('top-job');


$(function(){
	linker.init();
	slideScroll({
		easing : 'easeOutExpo',
		speed : 700,
		not: '.st-Header_Menu_Btn_Link, .card, .is-Tab_Nav_Item_Link, .sw-Lightbox_Btn, .sw-Lightbox_Close'
	});

	origin.$window.on("scroll", function(){
		if( !origin.VPisMobile ){
			$(".st-Header").css("left", -$(window).scrollLeft());
		};
	});

	$('.st-Header_Menu_Btn_Link').menu();
	$('.main-Fit').fitImages();
	$('.main-Fit-retina').fitImages({
		isHalf: true
	});

	$('.sw-Fade,.sw-ShiftFade').fadeContents();

	$('.main-Carousel').on('init', function(){
		origin.$window.trigger('fadeInit');
	}).slick({
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1
	});
	localmenu();

	if( $('#sortIndex').length ){
		sort();
	};

	$('.card').fancybox();

	page2top();

	$('.is-Tab').tab();

	$('.sw-Lightbox_Btn').lightbox();

	topJob();
});


//////////////////
// WEBPACK FOOTER
// ./dev/js/components.js
// module id = 0
// module chunks = 0